const { axios, axiosRetryInstance, API_URL, generateHeaders, queryParamsToPathParams, loopPagenationResults, loadConstants } = require('./helper');
const constants = loadConstants();

/**
 * @description returns a claim by claim number with service lines
 * @param {String} claimNumber the JV claim number
 */
const getClaimByClaimNumber = async (claimNumber) => {
    const params = {
        claimNumber: claimNumber
    };

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/claim/claims`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

/**
 * @description returns a claim list by claim numbers with service lines
 * @param {String} claimNumberList the list of JV claim numbers
 */
const getClaimByClaimNumberList = async (claimNumberList) => {
    try {
        const response = await axiosRetryInstance.get(`claims/readClaimByClaimNumberList`, {
            headers: generateHeaders(),
            params: {
                claimNumberList: claimNumberList.join(',')
            }
        });

        return response.data?.parsedResponse;
    }
    catch (e) {
        if (e && e.response) return { errorCode: e.response.status };

        return { errorCode: 500 };
    }
}

/**
 * @description returns a list of claimsby patientid
 * @param {String} patientId the JV employeeId or dependentId
 */
const searchClaimsByPatientId = async (patientId) => {
    const params = {
        patientId: patientId
    }
    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/claim/searchClaims`);
    const response = await axios.get(url, {
        headers: generateHeaders()
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const getAllClaimsByPatientId = async (patientId) => {
    const response = await searchClaimsByPatientId(patientId);
    const results = await loopPagenationResults("AdjudicationResult", response);
    return results;
};

/**
 * @description returns an EOB document for a claim
 * @param {} claimNumber the JV claim number
 * @param {} entityType the entity type
 */
const getEobByClaimNumberAndEntity = async (claimNumber, entityType) => {
    const params = {
        claimNumber: claimNumber,
        EntityType: entityType,
    };

    let url = queryParamsToPathParams(params, `${API_URL}pureProxy/document/getEOB`);
    const response = await axios.get(url, {
        headers: generateHeaders(null, { 'accept': 'application/octet-stream', responseType: 'arraybuffer' })
    });
    if (response.status !== 200) {
        return null;
    }
    return response.data;
}

const getEobByClaimNumberPatient = async (claimNumber) => {
    return await getEobByClaimNumberAndEntity(claimNumber, constants.ENTITYTYPE.Patient);
}

const getEobByClaimNumberProvider = async (claimNumber) => {
    return await getEobByClaimNumberAndEntity(claimNumber, constants.ENTITYTYPE.Provider);
}

module.exports = {
    getClaimByClaimNumber,
    getClaimByClaimNumberList,
    searchClaimsByPatientId,
    getAllClaimsByPatientId,
    getEobByClaimNumberPatient,
    getEobByClaimNumberProvider,
};